module.exports = __webpack_public_path__ + "static/media/fire-2.f53225a2.svg";